module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHABQpqrcNpgAAAMhJREFUWMPtl8ENgCAMRW13cA496GYyRUfjonM4BJ5ICCkgKoVEOKv/8VubXzDGDDlHrSr6AmmCnO/BHQBXdBrn6LPHuWfBJAHUqkxKNAaTgggC2Fs/FfcdCYGwAG9unesGSohbJ7kGRgnxGAQOlQ9K3T7kAkqKc7OkWgmsC9V7ALZlE7Xfnw3t/AUdoAP8F4A0gRujJGcAaYJeArR5TbIMbjxDN0JLQPjZsK0eKO0Cl4yRW61KQIRieZuLSROr2VNHPl9OS6/nF5anmhNSPxH1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_p.png
// module id = 8h30
// module chunks = 1